<template>
	<div>
		<div class="page_header">
			<span class="page_title">{{$t('maintenancemanagement.repairRegistration')}}</span>
			<el-form :inline="true" :size="size" style="flex:1;text-align: right;">
				<el-form-item :label="$t('time.timeQuery')">
					<el-date-picker v-model="queryTime" type="daterange" :range-separator="$t('time.to')"
						:start-placeholder="$t('time.startTimeHolder')" :end-placeholder="$t('time.endTimeHolder')"
						:picker-options="pickerOptions" value-format="yyyy-MM-dd">
					</el-date-picker>

				</el-form-item>
				<!-- 				<el-form-item :label="$t('maintenancemanagement.carNo')">
					<el-select style="width: 100%;" filterable v-model="carNoselect" :placeholder="$t('public.select')">
						<el-option v-for="item in vehicles.data" v-if="item.treeLevel == 5" :key="item.nodeValue"
							:label="item.name" :value="item.nodeValue">
						</el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item :label="$t('maintenancemanagement.carNo')">
					<el-input v-model="carNoselect" :placeholder="$t('maintenancemanagement.inputcarNo')"
						clearable></el-input>
				</el-form-item>
			</el-form>
		</div>
		<div style="margin:10px 0px">
			<el-form :inline="true" :size="size" style="flex:1;text-align: right;">
				<el-form-item :label="$t('maintenancemanagement.maintenanceShop')">
					<el-input v-model="maintenanceShop" clearable
						:placeholder="$t('maintenancemanagement.pleaseEnterrepairshop')"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button  type="primary" @click="onQueryClick" :loading="loading">{{
				        $t('public.query') }}</el-button>
				</el-form-item>
				<el-form-item>
					<el-button plain :size="size" type="primary" style="margin-left:10px"
						@click="download">{{ $t("public.export")}}</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div style="background: #C5D0E2;height: 1px;margin:10px 0px"></div>
		<div class="container">
			<div class="left-sidebar" style="display: flex;flex-direction: column;height: 100%;">
				<div style="display: flex;flex-direction: row;margin-right: 30px;position: relative;">
					<div>
						<i style="vertical-align: -9%;" class="iconfont icon-icon_tab_list"></i>
						<span style="margin-left:10px;font-size: 12px;font-weight: bold;">
							{{$t('maintenancemanagement.repairmainTable')}}</span>
					</div>
					<div class="addbutton" style="font-size:12px" @click="addrepair">
						<el-link :underline="false" style="margin-right:20px"><i class="el-icon-plus"
								style="height: 16px;width:16px;font-weight:bold;"></i>
							{{$t("public.newbuilt")}}</el-link>
					</div>
				</div>
				<div style="margin: 20px 30px 0px 0px;">
					<el-table :data="tableData" border style="width:958px" :size="size" max-height="386"
						highlight-current-row ref='table' @current-change="rowclick">
						<el-table-column type="index" align="center" :label="$t('public.index')">
							<!-- 	<template slot-scope="scope">
								{{ (currentPage - 1) * pageSize + scope.$index + 1 }}
							</template> -->

						</el-table-column>
						<el-table-column prop="RepairorderNo" :label="$t('maintenancemanagement.repairOrderNo')"
							align="center">
						</el-table-column>
						<el-table-column prop="CarNo" :label="$t('failure.carNo')" align="center">
						</el-table-column>

						<el-table-column prop="RepairDate" :label="$t('maintenancemanagement.repairDate')" align="center">
						</el-table-column>
						<el-table-column prop="RepairShop" :label="$t('maintenancemanagement.repairShop')" align="center">
						</el-table-column>
						<el-table-column prop="Paymentmethod" :label="$t('maintenancemanagement.paymentMethod')" align="center"
							show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="SparepartsCost" :label="$t('maintenancemanagement.fittingsCost')" align="center"
							show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="LaborCost" :label="$t('maintenancemanagement.laborCosts')" align="center"
							show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="amount" :label="$t('maintenancemanagement.amountofmoney')" align="center"
							show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="Entryclerk" :label="$t('maintenance.OPTName')" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column prop="Remark" :label="$t('operatormgr.opt_Memo')" show-overflow-tooltip align="center">
						</el-table-column>
						<el-table-column :label="$t('public.Operation')" fixed="right" align="center" width="180">
							<template slot-scope="scope">
								<el-button size="mini" type='success' @click="modify(scope.$index, scope.row)">{{ $t("public.edit")
						    }}</el-button>
								<el-button size="mini" type="danger" @click="handleDelete(scope.$index,tableData)">{{ $t("public.del")
						    }}</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div style="text-align: right;margin-top:8px;margin-right: 40px" class="pagination" v-show="total>0">
					<!--  -->
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
				<el-dialog class="addrepairlist" :title="repairname" :visible.sync="dialogFormVisible" :width="LanguageId  == 1 ? '400px' : '550px'" :close-on-click-modal="false">
					<div style="background: #E8F0FF;height: 1px;"></div>
					<div class="registrationInfo">
						{{ $t("maintenancemanagement.registrationinfo")}}
					</div>
					<el-form :inline="true" :model="registrationInfo" class="demo-form-inline" label-position="right"
						ref="registrationInfo" :rules="rules" size="mini" :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '200px'"
						style="margin: 10px 0px 10px 0px;">
						<el-form-item :label="$t('maintenancemanagement.repairDate')+'：'" prop="RepairDate">
							<el-col>
								<el-date-picker type="date" :placeholder="$t('maintenancemanagement.inputrepairDate')"
									v-model="registrationInfo.RepairDate" :picker-options="pickerOptions"
									value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
							</el-col>
						</el-form-item>
						<el-form-item :label="$t('maintenancemanagement.repairOrderNo')+'：'" style="margin-top: 10px;">
							<el-input v-model="registrationInfo.RepairorderNo"
								:placeholder="$t('maintenancemanagement.inputrepairOrderNo')" clearable
								:disabled="true"></el-input>
						</el-form-item>

						<el-form-item :label="$t('maintenancemanagement.carNo')" prop="CarNo" style="margin-top: 10px;">
							<el-select style="width: 100%;" filterable v-model="registrationInfo.MaintainVehicleID"
								:placeholder="$t('public.select')">
								<el-option v-for="item in vehicles.data" v-if="item.treeLevel == 5"
									:key="item.nodeValue" :label="item.vehicleName" :value="item.nodeValue">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('maintenancemanagement.maintenanceShop')" style="margin-top: 10px;">
							<el-input v-model="registrationInfo.RepairShop" :placeholder="$t('maintenancemanagement.pleaseEnterrepairshop')"  clearable></el-input>
						</el-form-item>
						<el-form-item :label="$t('maintenancemanagement.paymentMethod')+'：'" prop="Paymentmethod" style="margin-top: 10px;">
							<el-select v-model="registrationInfo.Paymentmethod" :placeholder="$t('maintenancemanagement.inputpaymentMethod')">
								<el-option :label="$t('maintenancemanagement.cash')"  value="现金"></el-option>
								<el-option :label="$t('maintenancemanagement.transferaccounts')" value="转账"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('maintenance.OPTName')+'：'"  style="margin-top: 10px;">
							<el-input v-model="registrationInfo.Entryclerk" :placeholder=
						 "$t('maintenancemanagement.inputperson')"
								:disabled="true"></el-input>
						</el-form-item>
					</el-form>
					<el-form :inline="true" :model="registrationInfo" class="demo-form-inline" label-position="right"
						size="mini"  :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '200px'" style="margin: 10px 0px 10px 0px;">
						<el-form-item  :label="$t('operatormgr.opt_Memo')+'：'" >
							<el-input type="textarea" v-model="registrationInfo.Remark" :placeholder="$t('operatormgr.please_opt_Memo')" 
								clearable></el-input>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer" style="text-align: right;margin:0px 20px 0px 10px">
						<el-button size="small" @click="dialogFormVisible = false">
							{{$t('public.cancel')}}</el-button>
						<el-button size="small" type="primary" @click="determine('registrationInfo')">{{$t('public.confirm')}}</el-button>
					</div>
				</el-dialog>
			</div>
			<div class="separator"></div>
			<div class="main-content">
				<div style="display: flex;flex-direction: row;margin-left: 40px;margin-right: 30px;position: relative;">
					<div>
						<i style="vertical-align: -9%;" class="iconfont icon-icon_tab_list"></i>
						<span style="margin-left:10px;font-size: 12px;font-weight: bold;">
							{{$t("maintenancemanagement.maintenanceHour")}}</span>
					</div>
					<div class="addbutton" style="font-size:12px" @click="addnewScheduleVisible">
						<el-link :underline="false" style="margin-right:20px"><i class="el-icon-plus"
								style="height: 16px;width:16px;font-weight:bold;"></i>
							{{$t("public.newbuilt")}}</el-link>
					</div>
				</div>
				<div style="margin: 20px 0px 0px 40px;">
					<el-table :data="timeSchedule" border  :size="size" max-height="246"
						highlight-current-row ref='table' @row-click="schedulerowclick">
						<!-- 
						<el-table-column type="selection" width="55">
						</el-table-column> -->
						<el-table-column type="index" align="center" :label="$t('public.index')">
							<template slot-scope="scope">
								{{ (currenttimePage - 1) * timepageSize + scope.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column prop="ManhourItem" :label="$t('maintenancemanagement.workhourproject')" align="center">
						</el-table-column>
						<el-table-column prop="amount" :label="$t('maintenancemanagement.amountofmoney')" align="center">
						</el-table-column>

						<el-table-column prop="RepairDate" :label="$t('maintenancemanagement.repairDate')" align="center">
						</el-table-column>

						<el-table-column :label="$t('public.Operation')" fixed="right" align="center" width="180">
							<template slot-scope="scope">
								<el-button size="mini" type='success'
									@click="modifynewSchedule(scope.$index, scope.row)">{{ $t("public.edit")
						    }}</el-button>
								<el-button size="mini" type="danger"
									@click="handleDeletenewSchedule(scope.$index, timeSchedule)">{{ $t("public.del")
						    }}</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div style="text-align: right;margin-top:8px;margin-right: 40px" class="pagination"
						v-show="items.length>0"> <!--  -->
						<el-pagination @size-change="handleSizeChangetime" @current-change="handleCurrentChangetime"
							:current-page="currenttimePage" :page-sizes="[10, 20, 30, 40]" :page-size="timepageSize"
							layout="total, sizes, prev, pager, next, jumper" :total="items.length">
						</el-pagination>
					</div>

					<el-dialog class="addrepairTimelist" :title="maintenancetitle" :visible.sync="newScheduleVisible" :width="LanguageId  == 1 ? '310px' : '470px'" :close-on-click-modal="false">
						<div style="background: #E8F0FF;height: 1px;"></div>
						<div class="registrationInfo">
							{{$t("maintenancemanagement.maintenancehours")}}
						</div>
						<el-form :model="repairTimelist" :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '200px'" size="mini" style="margin-top: 10px;"
							:rules="rules" ref="repairTimelist">
							<el-form-item :label="$t('maintenancemanagement.repairOrderNo')+'：'" style="margin-top: 13px;">
								<el-input v-model="repairTimelist.RepairorderNo" clearable :disabled="true"></el-input>
							</el-form-item>
							<el-form-item :label="$t('maintenancemanagement.repairDate')+'：'" style="margin-top: 13px;">
								<el-input v-model="repairTimelist.RepairDate" clearable :disabled="true"></el-input>
							</el-form-item>

							<el-form-item :label="$t('maintenancemanagement.workhourproject')+'：'" style="margin-top: 13px;" prop="ManhourItem" :rules="{
							      required: true, message: this.$t('maintenancemanagement.workhourcannotempty'), trigger: 'blur'
							    }">
								<el-input clearable v-model="repairTimelist.ManhourItem"></el-input>
							</el-form-item>
							<el-form-item :label="$t('maintenancemanagement.amount')" 
							style="margin-top: 13px;" prop="amount">
								<el-input clearable v-model="repairTimelist.amount"></el-input>
							</el-form-item>
						</el-form>
						<div slot="footer" class="dialog-footer" style="text-align: right;margin:20px 20px 0px 10px">
							<el-button size="small" @click="cancelSchedule('repairTimelist')">{{$t('public.cancel')}}</el-button>
							<el-button size="small" type="primary"
								@click="Scheduledetermine('repairTimelist')">{{$t('public.confirm')}}</el-button>
						</div>
					</el-dialog>
				</div>
				<div style="display: flex;flex-direction: row;margin: 30px 30px 0px 40px;position: relative;">
					<div>
						<i style="vertical-align: -9%;" class="iconfont icon-icon_tab_list"></i>
						<span style="margin-left:10px;font-size: 12px;font-weight: bold;">{{$t('maintenancemanagement.maintenanceAppendix')}}</span>
					</div>
					<div class="addbutton" style="font-size:12px" @click="addnewmainAppendix('newmainAppendixInfo')">
						<el-link :underline="false" style="margin-right:20px"><i class="el-icon-plus"
								style="height: 16px;width:16px;font-weight:bold;"></i>
							{{$t("public.newbuilt")}}</el-link>
					</div>
				</div>
				<div style="margin: 20px 0px 0px 40px;">
					<el-table :data="maintenanceParts" border :size="size" max-height="246">

						<el-table-column type="index" align="center" :label="$t('public.index')">
							<template slot-scope="scope">
								{{ (currentAppendixPage - 1) * AppendixpageSize + scope.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column prop="PartName" :label="$t('maintenancemanagement.accessoryName')" align="center">
						</el-table-column>
						<el-table-column prop="UnitPrice" :label="$t('maintenancemanagement.unitPrice')"  align="center"
						</el-table-column>
						<el-table-column prop="Quantity" :label="$t('maintenancemanagement.quantity')" align="center">
						</el-table-column>
						<el-table-column prop="Amount" :label="$t('maintenancemanagement.amountofmoney')" align="center">
						</el-table-column>

						<el-table-column prop="RepairDate" :label="$t('maintenancemanagement.repairDate')" align="center">
						</el-table-column>

						<el-table-column :label="$t('public.Operation')" fixed="right" align="center" width="180">
							<template slot-scope="scope">
								<el-button size="mini" type='success'
									@click="modifymaintenanceParts(scope.$index, scope.row)">{{ $t("public.edit")
						    }}</el-button>
								<el-button size="mini" type="danger"
									@click="handleDeletemainAppendix(scope.$index, maintenanceParts)">{{ $t("public.del")
						    }}</el-button>
							</template>
						</el-table-column>

					</el-table>
					<div style="text-align: right;margin-top:8px;margin-right: 40px" class="pagination"
						v-show="appendixitems.length>0"> 
						<el-pagination @size-change="handleSizeChangeAppendix"
							@current-change="handleCurrentChangeAppendix" :current-page="currentAppendixPage"
							:page-sizes="[10, 20, 30, 40]" :page-size="AppendixpageSize"
							layout="total, sizes, prev, pager, next, jumper" :total="appendixitems.length">
						</el-pagination>
					</div>
					<el-dialog class="newmainAppendixlist" :title="newmainAppendixTitle"
						:visible.sync="newmainAppendixVisible" :width="(LanguageId  == 1 ||LanguageId  == 2) ? '360px' : '460px'" :close-on-click-modal="false">
						<div style="background: #E8F0FF;height: 1px;"></div>
						<div class="registrationInfo">
							{{$t('vehicleInfo.accessoriesInfo')}}
						</div>
						<el-form :inline="true" :model="newmainAppendixInfo" class="demo-form-inline" :rules="rules" :label-width="(LanguageId  == 1 ||LanguageId  == 2) ? '100px' : '200px'"
							ref="newmainAppendixInfo" label-position="right" size="mini" 
							style="margin: 16px 0px 10px 0px;">
							<el-form-item :label="$t('maintenancemanagement.repairOrderNo')+'：'">
								<el-input v-model="newmainAppendixInfo.RepairorderNo" 
								:placeholder="$t('maintenancemanagement.inputrepairOrderNo')" clearable
									:disabled="true"></el-input>
							</el-form-item>
							<el-form-item :label="$t('maintenancemanagement.repairDate')+'：'"  style="margin-top: 10px;">
								<el-input v-model="newmainAppendixInfo.RepairDate" :placeholder="$t('maintenancemanagement.inputrepairDate')" clearable
									:disabled="true"></el-input>
							</el-form-item>

							<el-form-item :label="$t('maintenancemanagement.accessoryName')+'：'" prop="PartName" style="margin-top: 10px;">
								<el-input v-model="newmainAppendixInfo.PartName" :placeholder="$t('maintenancemanagement.inputaccessoryName')"
									clearable></el-input>
							</el-form-item>
							<el-form-item :label="$t('maintenancemanagement.price')"  prop="UnitPrice" style="margin-top: 10px;">
								<el-input v-model="newmainAppendixInfo.UnitPrice" :placeholder="$t('maintenancemanagement.inputunitPrice')" clearable
									@input="calc()"></el-input>
							</el-form-item>
							<el-form-item :label="$t('maintenancemanagement.quantity')+'：'" prop="Quantity" style="margin-top: 10px;">
								<el-input v-model="newmainAppendixInfo.Quantity" :placeholder="$t('maintenancemanagement.inputquantity')" clearable
									@input="calc()"></el-input>
							</el-form-item>
							<el-form-item :label="$t('maintenancemanagement.amount')" style="margin-top: 10px;">
								<el-input type="number" v-model.number="newmainAppendixInfo.Amount" :placeholder="$t('maintenancemanagement.entertheamount')"
									clearable readonly></el-input>
							</el-form-item>
						</el-form>
						<div slot="footer" class="dialog-footer" style="text-align: right;margin:0px 20px 0px 10px">
							<el-button size="small" @click="canclemainAppendix('newmainAppendixInfo')">
							{{$t('public.cancel')}}</el-button>
							<el-button size="small" type="primary"
								@click="determinnewmainAppendix('newmainAppendixInfo')">{{$t('public.confirm')}}</el-button>
						</div>
					</el-dialog>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import language from '@/utils/getLanguageId';
	import {
		forEach
	} from 'element-resize-detector/src/collection-utils';
	import {
		mapState
	} from 'vuex'
	export default {
		name:"repairregistration",
		components: {

		},
		data() {
			return {
				spantip: false,
				loading: false,
				newScheduleVisible: false,
				dialogFormVisible: false,
				newmainAppendixVisible: false,
				repairname: "",
				queryTime: [],
				total: 0,
				currentPage: 1,
				pageSize: 10,
				currenttimePage: 1,
				timepageSize: 10,
				currentAppendixPage: 1,
				AppendixpageSize: 10,
				appendixitems: [],
				items: [], // 工时要分页显示的数组
				// form: {
				// 	VID: "",
				// },
				carNoselect: "",
				maintenanceShop: "",
				tableData: [],
				timeSchedule: [],
				maintenanceParts: [],
				fullWidth: 0,
				registrationInfo: {
					RepairDate: new Date(),
					Paymentmethod: this.$t('maintenancemanagement.cash')
				},
				maintenancetitle: "",
				newmainAppendixTitle: "",
				repairTimelist: {},
				selectionrepair: {},
				newmainAppendixInfo: {},
				maintainID: 0,
				selectiontable: [],
				begindate: "",
				enddate: "",
				LanguageId:1,
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},
				rules: {
					MaintainVehicleID: [{
						required: true,
						message:  this.$t('maintenancemanagement.selectvehicle'),
						trigger: 'change'
					}],
					amount: [{
							required: true,
							message: this.$t('maintenancemanagement.entertheamount'),
							trigger: 'blur'
						},
						{
							pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
							message: this.$t('maintenancemanagement.validamount'),
							trigger: "blur"
						}
					],
					UnitPrice: [{
							required: true,
							message: this.$t('maintenancemanagement.entertheamount'),
							trigger: 'blur'
						},
						{
							pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
							message: this.$t('maintenancemanagement.validamount'),
							trigger: "blur"
						}
					],
					Quantity: [{
						required: true,
						message: this.$t('maintenancemanagement.inputquantity'),
						trigger: 'blur'
					}, {
						pattern: /^(0|[1-9][0-9]*)$/g,
						message: this.$t('maintenancemanagement.validnumber'),
						trigger: "blur"
					}],
					PartName: [{
							required: true,
							message: this.$t('maintenancemanagement.inputaccessoryName'),
							trigger: 'blur'
						},

					],
				}
			}
		},
		mounted() {
			//监听屏幕宽度
			var that = this;
			 that.LanguageId = language(that.$store.getters.locale)
			window.onresize = () => {
				return (() => {
					window.fullWidth = document.documentElement.clientWidth;
					that.fullWidth = window.fullWidth;
				})();
			};
			let myDate = new Date();
			that.begindate = that.getNextDate(myDate, -30);
			that.enddate = that.getNextDate(myDate, 0);
			that.queryTime = [that.begindate, that.enddate];
			that.queryMMInfoByComID(that.begindate, that.enddate, '', 0);

		},

		computed: {
			size() {
				return this.$store.getters.size
			},
			...mapState({
				operator: state => state.user.operator,
				vehicles: state => state.app.vehicles,
			}),
		},
		methods: {
			handleSizeChangetime(val) {
				this.timepageSize = val;
				this.handleCurrentChangetime(this.currenttimePage);
			},
			handleCurrentChangetime(val) {
				this.currenttimePage = val;
				const start = (this.currenttimePage - 1) * this.timepageSize;
				const end = start + this.timepageSize;
				this.timeSchedule = this.items.slice(start, end);
			},
			handleSizeChangeAppendix(val) {
				this.AppendixpageSize = val;
				this.handleCurrentChangeAppendix(this.currentAppendixPage);
			},
			handleCurrentChangeAppendix(val) {
				this.currentAppendixPage = val;
				const start = (this.currentAppendixPage - 1) * this.AppendixpageSize;
				const end = start + this.AppendixpageSize;
				this.maintenanceParts = this.appendixitems.slice(start, end);
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.queryMMInfoByComID(this.begindate, this.enddate, '', 0);
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.queryMMInfoByComID(this.begindate, this.enddate, '', 0);
			},
			getNextDate(date, day) {
				const dd = new Date(date);
				dd.setDate(dd.getDate() + day);
				const y = dd.getFullYear();
				const m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
				const d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
				return y + "-" + m + "-" + d;
			},
			calc() {
				this.newmainAppendixInfo.Amount = (this.newmainAppendixInfo.UnitPrice * this.newmainAppendixInfo.Quantity)
					.toFixed(2);
			},
			handleSelectionChange(val) {
				this.selectiontable = val;
			},
			modify(index, row) {
				console.log(row)
				this.dialogFormVisible = true;
				this.repairname = this.$t('maintenancemanagement.modifymaintenancetable');
				this.maintainID = row.MaintainID;
				// this.registrationInfo.repairOrderNo=row.RepairorderNo;
				const {
					RepairDate,
					RepairorderNo,
					MaintainVehicleID,
					CarNo,
					RepairShop,
					Paymentmethod,
					Entryclerk,
					Remark
				} = row;
				console.log(row)
				this.registrationInfo = JSON.parse(JSON.stringify(row)); ////数据赋值 深拷贝代替浅拷贝

			},
			addrepair() {
				this.dialogFormVisible = true;
				this.repairname = this.$t('maintenancemanagement.createnewmaintenance');
				this.$nextTick(() => {
					this.$refs["registrationInfo"].clearValidate();
				})
				this.registrationInfo = {};
				this.registrationInfo.Entryclerk = this.operator.OpeName;
				this.$set(this.registrationInfo, "RepairDate", new Date());
			},
			addnewScheduleVisible() {
				this.newScheduleVisible = true;
				this.maintenancetitle = this.$t('maintenancemanagement.newHourSchedule');
				this.repairTimelist = {};
				this.repairTimelist.RepairorderNo = this.selectionrepair.RepairorderNo;
				this.repairTimelist.RepairDate = this.selectionrepair.RepairDate;
				this.repairTimelist.MaintainID = this.selectionrepair.MaintainID;

			},
			modifynewSchedule(index, row) {
				this.newScheduleVisible = true;
				this.maintenancetitle = this.$t('maintenancemanagement.revisehoursSchedule');
				this.repairTimelist = JSON.parse(JSON.stringify(row)); ////数据赋值 深拷贝代替浅拷贝

			},
			Scheduledetermine(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.maintenancetitle == this.$t('maintenancemanagement.newHourSchedule')) {
							this.saveMMWorkHourInfo(-1, 1, this.$t('public.add_success'));
						} else if (this.maintenancetitle == this.$t('maintenancemanagement.revisehoursSchedule')) {
							this.saveMMWorkHourInfo(this.repairTimelist.WorkHourID, 2, this.$t(
								'public.edit_success'));
						}
					} else {
						// console.log('error submit!!');
						return false;
					}
				});
			},
			cancelSchedule(formName) {
				this.newScheduleVisible = false;
				this.$refs[formName].resetFields();

			},
			// 添加、修改、删除维修工时附表
			saveMMWorkHourInfo(workHourID, type, message) {
				var that = this;
				that.$api.saveMMWorkHourInfo({
					WorkHourID: workHourID,
					MaintainID: that.repairTimelist.MaintainID,
					RepairorderNo: that.repairTimelist.RepairorderNo,
					RepairDate: that.repairTimelist.RepairDate,
					ManhourItem: that.repairTimelist.ManhourItem,
					Amount: that.repairTimelist.amount,
					operate: type
				}).then((res) => {
					if (res.code == 200) {
						that.newScheduleVisible = false;
						that.$message({
							type: 'success',
							message: message
						});
						that.queryMMPartAndWorkHourInfo(that.repairTimelist.MaintainID);
						that.repairTimelist = {};

					} else {
						this.$message({
							type: 'info',
							message: res.message
						});
					}
				})
			},
			handleDeletenewSchedule(index, row) {
				this.$confirm(this.$t('maintenance.confirmDelete')+'?', this.$t('public.tips'), {
					confirmButtonText: this.$t('public.confirm'),
					cancelButtonText: this.$t('public.cancel'),
					type: 'warning'
				}).then(() => {
					const {
						MaintainID,
						RepairorderNo,
						RepairDate,
						ManhourItem,
						amount,
						WorkHourID
					} = row[index];
					this.repairTimelist = JSON.parse(JSON.stringify(row[index])); ////数据赋值 深拷贝代替浅拷贝
					this.saveMMWorkHourInfo(this.repairTimelist.WorkHourID, 3, this.$t('public.hasDeleted'));
					// row.splice(index, 1);

				}).catch(() => {
					// this.$message({
					//   type: 'info',
					//   message: '已取消删除'
					// });          
				});
			},
			schedulerowclick(val) {


			},
			handleDelete(index, row) {
				this.$confirm(this.$t('maintenance.confirmDelete')+'?', this.$t('public.tips'), {
					confirmButtonText: this.$t('public.confirm'),
					cancelButtonText:this.$t('public.cancel'),
					type: 'warning'
				}).then(() => {
					const {
						RepairDate,
						MaintainID,
						RepairorderNo,
						CarNo,
						RepairShop,
						Paymentmethod,
						Entryclerk,
						Remark,
					} = row[index];
					this.registrationInfo = JSON.parse(JSON.stringify(row[index])); ////数据赋值 深拷贝代替浅拷贝
					this.saveMMInfo(this.registrationInfo.MaintainID, 3, this.$t('public.hasDeleted'));
					// row.splice(index, 1);
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},

			selectRow(row) { // 给操作行 高亮
				if (row) {
					this.$refs.table.setCurrentRow(row, true); // 高亮某一行
				} else {
					this.$refs.table.setCurrentRow(); // 取消高亮
				}
			},
			onQueryClick() {
				if (!this.queryTime || this.queryTime.length == 0) {
				    this.$message.warning(this.$t("time.selectQueryTime"));
				    return;
				}
				this.begindate = this.queryTime[0];
				this.enddate = this.queryTime[1];
				this.queryMMInfoByComID(this.begindate, this.enddate, this.carNoselect, 0)
			},
			rowclick(val) {
				 if (!val || !val.MaintainID) {
				    this.selectionrepair = {}; // 清空选中记录
				    this.timeSchedule = []; // 清空工时表
				    this.maintenanceParts = []; // 清空配件表
				    return;
				  }
				  this.selectionrepair = val;
				  // 用点击行的值中的维修单号去查工时附表和配件附表
				  this.queryMMPartAndWorkHourInfo(val.MaintainID);
			},

			queryMMPartAndWorkHourInfo(maintainID) {
				this.$api.queryMMPartAndWorkHourInfo({
					MaintainID: maintainID
				}).then((res) => {
					if (res && res.code == 200) {
						// this.timeSchedule = res.Repairtimeschedule;
						this.items = res.Repairtimeschedule;
						// this.maintenanceParts = res.Servicepartsschedule;
						this.appendixitems = res.Servicepartsschedule;
						this.handleCurrentChangetime(1);
						this.handleCurrentChangeAppendix(1);
					}
				})
			},
			determine(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.repairname == "新建维修主表") {
							this.saveMMInfo(0, 1, this.$t('public.add_success'));
						} else if (this.repairname == "修改维修主表") {
							this.saveMMInfo(this.maintainID, 2, this.$t('public.edit_success'));
						}
					} else {
						// console.log('error submit!!');
						return false;
					}
				});
			},

			saveMMInfo(maintainID, type, message) {
				this.$api.saveMMInfo({
					CompanyID: this.operator.CompanyId,
					MaintainID: maintainID,
					RepairorderNo: this.registrationInfo.RepairorderNo,
					RepairDate: this.registrationInfo.RepairDate,
					MaintainVehicleID: this.registrationInfo.MaintainVehicleID,
					RepairShop: this.registrationInfo.RepairShop,
					Paymentmethod: this.registrationInfo.Paymentmethod == "现金" ? 1 : 2,
					Entryclerk: this.registrationInfo.Entryclerk,
					Remark: this.registrationInfo.Remark,
					operate: type
				}).then((res) => {
					if (res.code == 200) {
						this.registrationInfo = {};
						this.dialogFormVisible = false;
						this.$message({
							type: 'info',
							message: message,
						});
						let myDate = new Date();
						this.begindate = this.getNextDate(myDate, -30);
						this.enddate = this.getNextDate(myDate, 0);
						let newPageing = Math.ceil((this.tableData.length - 1) / this
						.pageSize); //Math.ceil向上取整算出新的分页
						let newcurrentPage = this.currentPage > newPageing ? newPageing : this
						.currentPage; //计算当前页应该是哪页
						this.currentPage = newcurrentPage < 1 ? 1 : newcurrentPage; //把当前页的值赋给this.page,重新渲染列表
						this.queryMMInfoByComID(this.begindate, this.enddate, '', 0);
					} else {
						this.$message({
							type: 'info',
							message: res.message,
						});
					}
				})
			},
			download() {
				if (this.tableData.length == 0) {
					this.$message.info(this.$t("statistics.PleQuery"));
					return;
				}
				this.queryMMInfoByComID(this.begindate, this.enddate, this.carNoselect, 1);
			},
			queryMMInfoByComID(begindate, enddate, vehicle, type) {
				var that = this;
				// that.loading = true;
				that.$api.queryMMInfoByComID({
					begindate: begindate,
					enddate: enddate,
					carNo: vehicle,
					repairShop: that.maintenanceShop,
					CompanyID: that.operator.CompanyId,
					PageNo: that.currentPage,
					PageSize: that.pageSize,
					IsExport: type
				}).then((res) => {
					if (type == 0 && res) {
						// that.loading = false;
						var newtableData = [];
						if (res.type == "application/json") {
							const reader = new FileReader();
							reader.readAsText(res, 'utf-8');
							reader.onload = function(e) {
								const readerres = reader.result;
								const parseObj = JSON.parse(readerres);
								// console.log(parseObj);
								that.total = parseObj.count;
								// console.log(that.total);
								if (parseObj.data.length > 0) {
									parseObj.data.forEach(element => {
										element.Paymentmethod = element.Paymentmethod == 1 ? "现金" :
											"转账";
										newtableData.push(element);
									})
									that.tableData = newtableData;
									that.rowclick(that.tableData[0]);
									that.loading = false;
								} else {
									that.tableData = [];
									that.timeSchedule = [];
									that.maintenanceParts = [];
									that.loading = false;
								}
							}
						}
					} else {
						that.loading = false;
						let blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						}); // 重点代码
						let a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute("download",that.$t('maintenancemanagement.repairRegistration') +
							`_${that.timestampToTime(new Date().getTime())}.xlsx`); // 表名，自定义
						a.click(); // 执行下载
						window.URL.revokeObjectURL(blob); // 释放ur
					}
				})
			},
			//时间戳转换为日期格式
			timestampToTime(timestamp) {
				var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
				var Y = date.getFullYear();
				var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			},
			addnewmainAppendix(formName) {
			  this.newmainAppendixVisible = true; // 显示弹窗
			  this.newmainAppendixTitle = this.$t('maintenancemanagement.newPartsAppendix');
			  // 步骤1：初始化表单所有字段（与表单绑定的prop对应）
			  this.newmainAppendixInfo = {
			    RepairorderNo: this.selectionrepair.RepairorderNo || '',
			    RepairDate: this.selectionrepair.RepairDate || '',
			    MaintainID: this.selectionrepair.MaintainID || '',
			    PartName: '', // 配件名称（必填）
			    UnitPrice: '', // 单价（必填）
			    Quantity: '', // 数量（必填）
			    Amount: ''    // 金额（计算得出）
			  };
			  
			  // 步骤2：用$nextTick等待表单渲染完成后，再调用resetFields()
			  this.$nextTick(() => {
			    if (this.$refs[formName]) { // 双重校验：确保$refs存在
			      this.$refs[formName].resetFields();
			    }
			  });
			},
			canclemainAppendix(formName){
				this.newmainAppendixVisible = false;
				this.$refs[formName].resetFields();
			},
			handleDeletemainAppendix(index, row) {
				this.$confirm(this.$t('maintenance.confirmDelete')+'?', this.$t('public.tips'), {
					confirmButtonText: this.$t('public.confirm'),
					cancelButtonText:  this.$t('public.cancel'),
					type: 'warning'
				}).then(() => {
					const {
						RepairDate,
						MaintainID,
						RepairorderNo,
						CarNo,
						RepairShop,
						Paymentmethod,
						Entryclerk,
						Remark,
						PartID,
						PartName,
						UnitPrice,
						Quantity,
						Amount
					} = row[index];
					this.newmainAppendixInfo = JSON.parse(JSON.stringify(row[index])); ////数据赋值 深拷贝代替浅拷贝
					this.saveMMPartInfo(this.newmainAppendixInfo.PartID, 3, this.$t('public.hasDeleted'));
					// row.splice(index, 1);
				}).catch(() => {
					// this.$message({
					//   type: 'info',
					//   message: '已取消删除'
					// });          
				});
			},
			saveMMPartInfo(partID, type, message) {
				this.$api.saveMMPartInfo({
					PartID: partID,
					MaintainID: this.newmainAppendixInfo.MaintainID,
					RepairorderNo: this.newmainAppendixInfo.RepairorderNo,
					RepairDate: this.newmainAppendixInfo.RepairDate,
					PartName: this.newmainAppendixInfo.PartName,
					UnitPrice: this.newmainAppendixInfo.UnitPrice,
					Quantity: this.newmainAppendixInfo.Quantity,
					Amount: this.newmainAppendixInfo.Amount,
					operate: type
				}).then((res) => {
					if (res.code == 200) {
						this.newmainAppendixVisible = false;
						this.$message({
							type: 'success',
							message: message,
						});
						this.queryMMPartAndWorkHourInfo(this.newmainAppendixInfo.MaintainID);
					} else {
						this.$message({
							type: 'info',
							message: res.message,
						});
					}

				})
			},
			modifymaintenanceParts(index, row) {
				this.newmainAppendixVisible = true;
				this.newmainAppendixTitle = this.$t('maintenancemanagement.modifypartsSchedule');
				this.newmainAppendixInfo = JSON.parse(JSON.stringify(row)); ////数据赋值 深拷贝代替浅拷贝
			},
			determinnewmainAppendix(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.newmainAppendixTitle == this.$t('maintenancemanagement.newPartsAppendix')) {
							this.saveMMPartInfo(-1, 1, this.$t('public.add_success'));
							
						} else if (this.newmainAppendixTitle == this.$t('maintenancemanagement.modifypartsSchedule')) {
							this.saveMMPartInfo(this.newmainAppendixInfo.PartID, 2, this.$t(
								'public.edit_success'));
						}
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	// .el-table__body tr.current-row>td{
	//   // background-color: #ff0000 !important;
	//    background-color: #69A8EA !important;
	//   color: #fff;
	// }
	.container {
		display: flex;
		margin-right: 20px;
		/* 设置容器为flex布局 */
	}

	.left-sidebar {
		width: 50%;
		/* 左侧边栏宽度 */
	}

	.addbutton {
		text-align: right;
		right: 0;
		position: absolute;
	}

	.main-content {
		flex: 1;
		width: 50%;
		/* 主内容区域自动占据剩余空间 */
	}

	.main-content::before {
		content: "";
		display: block;
		border-left: 1px solid #ccc;
		/* 或根据实际情况调整 */
	}

	.separator {
		border-left: 1px solid #D9E4F8;
		/* 设置左侧边框为红色 */
		margin-right: -1px;
		/* 移除右侧默认边框 */
	}

	.addrepairlist   {
		::v-deep	.el-dialog__body {
			padding-top: 0px;

		}
	}

	.addrepairlist   {
		::v-deep	.el-dialog__title {
			font-size: 14px;
			font-weight: bold !important;
			color: black;
		}
	}

	.registrationInfo {
		margin-top: 20px;
		font-size: 12px;
		text-align: left;
		font-weight: bold !important;
		margin-left: 20px;
		color: black;
	}

	.addrepairlist   {
		::v-deep	.el-dialog {
			height: 550px;
		}
	}

	.addrepairTimelist  {
		::v-deep .el-dialog {
			height: 373px;
		}
	}

	.addrepairTimelist   {
		::v-deep	.el-form-item__label {
			font-size: 12px;

		}
	}

	.addrepairTimelist  {
		::v-deep	.el-input__inner {
			font-size: 12px;
			width: 170px;
		}
	}

	.addrepairlist   {
		::v-deep	.el-form-item__label {
			font-size: 12px;

		}
	}

	.addrepairlist  {
		::v-deep	.el-input__inner {
			font-size: 12px;
			width: 250px;
		}
	}

	.addrepairlist  {
		::v-deep	.el-textarea__inner {
			width: 250px;

		}
	}

	.newmainAppendixlist   {
		::v-deep	.el-dialog {
			height: 500px;
		}
	}

	.newmainAppendixlist ::v-deep {
		.el-input__inner {
			font-size: 12px;
			width: 200px;
		}
	}

	.newmainAppendixlist ::v-deep {
		.el-form-item__label {
			font-size: 12px;

		}
	}
</style>